var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.address.address.street)+" "+_vm._s(_vm.address.address.houseNumber)+" "),(_vm.zipCode)?_c('span',{staticClass:"text-muted"},[_vm._v(" , "+_vm._s(_vm.address.address.zipCode)+" "+_vm._s(_vm.address.address.city)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }